'use client';

import cn from 'classnames';
import { type ComponentProps, type CSSProperties, forwardRef } from 'react';

import './variant-color-button.scss';

type VariantColorButtonProps = Omit<ComponentProps<'input'>, 'type' | 'checked' | 'className' | 'children'> & {
    label: string;
    colors: string[];
    isChecked?: boolean;
    isUnavailable?: boolean;
    inputClassName?: string;
    labelClassName?: string;
    labelTextClassName?: string;
};

export const VariantColorButton = forwardRef<HTMLInputElement, VariantColorButtonProps>(
    (
        {
            label,
            colors,
            isChecked,
            isUnavailable = false,
            inputClassName,
            labelClassName,
            labelTextClassName,
            ...rest
        },
        ref
    ) => {
        const [color1, color2] = colors;
        const style = {
            '--variant-bg-color': color2 ? `linear-gradient(${color1}, ${color2})` : color1,
        } as CSSProperties;

        return (
            <label
                style={style}
                className={cn('variant-color__label', labelClassName, {
                    selected: isChecked,
                    unavailable: isUnavailable,
                })}
            >
                <span className={cn('variant-color__label-text', labelTextClassName)}>{label}</span>
                <input
                    ref={ref}
                    {...rest}
                    type="radio"
                    checked={isChecked}
                    className={cn('variant-color__radio-input', inputClassName)}
                />
            </label>
        );
    }
);

VariantColorButton.displayName = 'VariantColorButton';
